const scheduleDateTime = new Date('March 03, 2022 00:00:00').getTime();
const todayTime = new Date().getTime();

export const dayAfterScheduledDate = (todayTime > scheduleDateTime);